<div class="bg-white p-3" style="border-radius: 10px;">
  <!-- Register Form -->
<div class="custom-form-group custom-form-group-form mt-3" [formGroup]="registerForm">
  
  <label class="custom-label">
    Registration Link
    <span class="star">*</span>
  </label>

  <div class="row align-items-center g-2 custom-register-input">
    <!-- Input field: half width on desktop, full width on mobile -->
    <div class="col-12 col-md-6 custom-input">
      <mat-form-field appearance="outline" class="w-100">
        <input
          matInput
          placeholder="Enter registration link"
          formControlName="partnership_link"
        />
      </mat-form-field>
    </div>

    <!-- Buttons: align horizontally on desktop, stack on mobile -->
    <div class="col-12 col-md-auto d-flex" style="gap: 20px;">
      <button
        mat-raised-button
        color="primary"
        (click)="saveRegistrationLink()"
        [disabled]="registerForm.invalid || loading"
      >
        {{ RegisterData?.partnership_link ? 'Update' : 'Save' }}
      </button>

      <button
        mat-stroked-button
        color="warn"
        type="button"
        (click)="cancelRegistrationLink()"
      >
        Cancel
      </button>
    </div>
  </div>
</div>


  <!-- Table -->
  <div class="table-container mb-3">
    <table class="table custom-table mb-0">
      <thead>
        <tr>
          <th>Registration Link</th>
        </tr>
      </thead>

      <tbody>
<tr>
  <ng-container *ngIf="RegisterData?.partnership_link && !loading">

    <td>
      <a [href]="RegisterData?.partnership_link" target="_blank">
        {{ RegisterData?.partnership_link }}
      </a>
    </td>
  </ng-container>

</tr>
       

<tr *ngIf="!RegisterData?.partnership_link && !loading">
  <td colspan="5" class="text-center py-3 text-muted">
    No registration links found.
  </td>
</tr>


</tbody>  
    </table>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="text-center p-3">
    Loading Partnership Links...
  </div>

</div>
